export default Object.freeze({
    amount: 400000,
    PROCESS_STATUS: {
        COMPLETED: 0,
        PROCESSING: 1,
        FAILED: 2,
    },

    CONTENT_TYPE: {
        VIDEO: 1,
        IMAGE: 2,
        OTHERS: 3
    },

    COURSE_TYPE: {
        CLASS: 1,
        ONLINE: 2,
        VIDEO: 3,
    },

    CLASS_TYPE: {
        WEEKEND: 1,
        WEEKDAY: 2,
        BOTH: 3
    },

    CLASS_TYPE_LABEL: {
        1: "ရုံးပိတ်ရက်အတန်း",
        2: "ရုံးဖွင့်ရက်အတန်း",
        3: "နှစ်ခုစလုံး"
    },

    ASSIGNMENT: {
        ERROR: {
            Type: "ဖိုင်အမျိုးစားမှားနေပါတယ်။",
            Max_Size: "ဖိုင် size သည် 5MB ထက်မကျော်ရပါ။",
            Max_Count: "သတ်မှတ်ထားသော ဖိုင်အရေအတွက်ထက် ကျော်နေပါသည်။",
            Expired: "Assignment Deadlineမှာ သတ်မှတ်ရက်ကို ကျော်သွားပါပြီ။"
        },
        MAX_FILE_COUNT: 5,
        MAX_FILE_SIZE : 5 * 1024 * 1024,
        ALLOWED_FILE_TYPES: [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/pdf",
            "application/vnd.ms-powerpoint", // ppt
            "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
            "application/vnd.openxmlformats-officedocument.presentationml.slideshow", //pps
            "application/msword", // doc
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // docx
        ],
        FILE_TYPE_ERROR: "File type not supported!",
        ALLOWED_EXTENSION: ".jpg,.jpeg,.png,.pdf,.doc,.docx,.ppt,.pptx,.pps",
    },

    ASSIGNMENT_ANSWER_STATUS: {
        SAVE: 0,
        APPLIED: 1,
        APPROVE: 2,
        REJECT: 3,
    },
    ASSIGNMENT_ANSWER_TEXT: {
        0: 'မှတ်ထားပြီး',
        1: 'လျှောက်ထားဆဲ',
        2: 'လက်ခံပြီး',
        3: 'ပယ်ဖျက်ပြီး',
    }
})
